// document.addEventListener("DOMContentLoaded", function () {
//   const printBtn = document.querySelector("[id^='printall-']");
//   if (!printBtn) return;

//   printBtn.addEventListener("click", async function (e) {
//     e.preventDefault();

//     // 1. Collect all blog post links from the rendered weekly blog section
//     const links = [...document.querySelectorAll(".weekly-blog-item a")]
//       .map(a => a.href)
//       .filter(href => href && href.includes("/blogs/"));

//     // Remove duplicate URLs
//     const uniqueLinks = [...new Set(links)];

//     if (uniqueLinks.length === 0) {
//       alert("No blog links found to print.");
//       return;
//     }

//     console.log(`📋 Processing ${uniqueLinks.length} blog posts...`);

//     let allArticlesHTML = "";
//     let processedCount = 0;

//     for (const url of uniqueLinks) {
//       try {
//         console.log(`📄 Fetching: ${url}`);
//         const response = await fetch(url);
//         const html = await response.text();

//         // Parse HTML
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, "text/html");

//         // 2. Try multiple selectors to find the actual article content
//         let articleContent = 
//           doc.querySelector(".rte") ||                    // Most common Shopify content
//           doc.querySelector("article .rte") ||
//           doc.querySelector(".article-content") ||
//           doc.querySelector(".blog-content") ||
//           doc.querySelector(".entry-content") ||
//           doc.querySelector("article") ||
//           doc.querySelector(".article-template") ||
//           doc.querySelector("main") ||
//           doc.body;

//         console.log(`📝 Content container:`, articleContent?.tagName || "NONE");

//         if (articleContent) {
//           // Log content length before cleanup
//           const beforeLength = articleContent.innerHTML.trim().length;
//           console.log(`📏 Before cleanup: ${beforeLength} chars`);
// /*-- --*/
//           const unwantedSelectors = [
//             "header",
//             "nav",
//             "footer",
//             "script",
//             "style",
//             ".articles-wrapper",
//             ".title-wrapper-with-link",
//             ".slider-mobile-gutter",
//             ".custom-buttons-below",
//             ".recipe-buttons",
//             ".hidden"
//           ];

//           unwantedSelectors.forEach(selector => {
//             articleContent.querySelectorAll(selector).forEach(el => el.remove());
//           });
// /*-- --*/
// // Do NOT remove elements based on text content or generic [class*="related"] etc.
// // Also do NOT touch links with /blogs/ inside the main article content.


//           // Log content length after cleanup
//           const afterLength = articleContent.innerHTML.trim().length;
//           console.log(`📏 After cleanup: ${afterLength} chars`);
//         }

//         // 3. FIXED: Lower threshold + always include if content exists   /*------
//         if (articleContent && articleContent.innerHTML.trim().length > 10) {
//           const title = doc.querySelector("title")?.textContent.replace(/\|.*$/, "").trim() || "Blog Post";
          
//           // Add title BEFORE cleanup affects structure
//           articleContent.insertAdjacentHTML("afterbegin", 
//             `<h2 style="color: #333; border-bottom: 2px solid #ccc; padding-bottom: 10px; margin-bottom: 20px;">${title}</h2>`
//           );

//           allArticlesHTML += `
//             <div class="print-article" style="page-break-after: always; margin: 0 20px;">
//               ${articleContent.innerHTML}
//             </div>
//           `;
//           processedCount++;
//           console.log(`✅ Added "${title}" to print`);
//         } else {
//           console.log(`❌ Skipped - content too short`);
//         }
//       } catch (err) {
//         console.error("❌ Error loading:", url, err);
//       }
//     }

//     console.log(`✅ Total processed: ${processedCount}/${uniqueLinks.length}`);

//     // 4. Open print window
//     const printWindow = window.open("", "", "width=800,height=900");
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print All Blog Posts</title>
//           <style>
//             @media print {
//               body { margin: 0; padding: 0; font-size: 12pt; }
//               .print-article { page-break-after: always; margin: 20px 0; }
//               img { max-width: 600px; width: 100%; height: auto; page-break-inside: avoid; }
//               h1, h2, h3 { page-break-after: avoid; }
//               table { width: 100%; border-collapse: collapse; }
//               table td, table th { border: 1px solid #ddd; padding: 8px; }
//             }
//             @media screen {
//               body { font-family: Arial, sans-serif; padding: 20px; max-width: 800px; margin: 0 auto; }
//               img { max-width: 600px; width: 100%; height: auto; }
//               .print-article { margin-bottom: 40px; border-bottom: 1px solid #eee; padding-bottom: 20px; }
//             }
//             * { box-sizing: border-box; }
//             body { line-height: 1.6; color: #333; }
//           </style>
//         </head>
//         <body>
//           <h1 style="text-align: center; margin-bottom: 30px; color: #2c5aa0;">All Blog Posts This Week</h1>
//           ${allArticlesHTML || '<p>No suitable content found. Check console (F12) for details.</p>'}
//         </body>
//       </html>
//     `);
//     printWindow.document.close();

//     printWindow.onload = function () {
//       printWindow.print();
//     };
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const printBtn = document.querySelector("[id^='printall-']");
  if (!printBtn) return;

  printBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    // 1. Collect all blog post links from the rendered weekly blog section
    const links = [...document.querySelectorAll(".weekly-blog-item a")]
      .map(a => a.href)
      .filter(href => href && href.includes("/blogs/"));

    // Remove duplicate URLs
    const uniqueLinks = [...new Set(links)];

    if (uniqueLinks.length === 0) {
      alert("No blog links found to print.");
      return;
    }

    console.log(`📋 Processing ${uniqueLinks.length} blog posts...`);

    let allArticlesHTML = "";
    let processedCount = 0;

    for (const url of uniqueLinks) {
      try {
        console.log(`📄 Fetching: ${url}`);
        const response = await fetch(url);
        const html = await response.text();

        // Parse HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // 2. Try multiple selectors to find the actual article content
        let articleContent = 
          doc.querySelector(".rte") ||                    // Most common Shopify content
          doc.querySelector("article .rte") ||
          doc.querySelector(".article-content") ||
          doc.querySelector(".blog-content") ||
          doc.querySelector(".entry-content") ||
          doc.querySelector("article") ||
          doc.querySelector(".article-template") ||
          doc.querySelector("main") ||
          doc.body;

        if (articleContent) {
          const unwantedSelectors = [
            "header", "nav", "footer", "script", "style",
            ".articles-wrapper", ".title-wrapper-with-link",
            ".slider-mobile-gutter", ".custom-buttons-below",
            ".recipe-buttons", ".hidden"
          ];

          unwantedSelectors.forEach(selector => {
            articleContent.querySelectorAll(selector).forEach(el => el.remove());
          });

          // Only add article content if it's not empty
          if (articleContent.innerHTML.trim().length > 0) {
            const title = doc.querySelector("title")?.textContent.replace(/\|.*$/, "").trim() || "Blog Post";
          
            // Add title
            articleContent.insertAdjacentHTML("afterbegin", 
              `<h2 style="color: #333; border-bottom: 2px solid #ccc; padding-bottom: 10px; margin-bottom: 20px;">${title}</h2>`
            );

            allArticlesHTML += `
              <div class="print-article recipe-section">
                ${articleContent.innerHTML}
              </div>
            `;
            processedCount++;
            console.log(`✅ Added "${title}" to print`);
          }
        }
      } catch (err) {
        console.error("❌ Error loading:", url, err);
      }
    }

    console.log(`✅ Total processed: ${processedCount}/${uniqueLinks.length}`);

    // 4. Open print window
    const printWindow = window.open("", "", "width=800,height=900");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print All Blog Posts</title>
          <style>
            @media print {
              @page {
                size: A4;
                margin: 1cm;
              }

              /* Hide UI elements */
              header, footer, nav, .recipe-buttons, .announcement-bar, 
              #shopify-section-header, #shopify-section-footer, #root {
                display: none !important;
              }

              /* Layout preservation */
              .recipe-container {
                display: grid !important;
                grid-template-columns: 35% 60% !important; 
                gap: 5%;
                width: 100% !important;
              }

              .recipe-image img {
                width: 100% !important;
                height: auto !important;
                border-radius: 5px;
              }

              .recipe-title { font-size: 22pt !important; text-transform: uppercase; }
              .recipe-ingredients, .recipe-instructions { font-size: 10.5px !important; line-height: 1.4 !important; }

              /* PAGE BREAK FIXES */
              .recipe-section {
                page-break-after: always !important;
                page-break-inside: avoid !important;
                margin: 0 20px;
                display: block;
              }

              /* REMOVE BLANK PAGE AT THE END */
              .recipe-section:last-child {
                page-break-after: auto !important;
              }

              /* Prevent empty tags from creating extra space/pages */
              div:empty, p:empty { display: none !important; }
            }
          </style>
        </head>
        <body>
          <h1 style="text-align: center; margin-bottom: 30px; color: #2c5aa0;">All Blog Posts This Week</h1>
          ${allArticlesHTML || '<p>No suitable content found.</p>'}
        </body>
      </html>
    `);
    printWindow.document.close();

    printWindow.onload = function () {
      // Small delay to ensure images are rendered before calculating breaks
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    };
  });
});